export interface IToggleStockImageVisibleRequest {
    image_id: string;
    visible: number;
}
